import http from './api'

const route = 'app/positivacaocliente/'

export default {
  showGraficoClientesNovos: (empresaSelect, cidades, areas, vendedores, redes, tokencontrato, valorMes, segmento) => {
    return http.post(route + 'showGraficoClientesNovos', {
      empresas: empresaSelect,
      cidades: cidades,
      areas: areas,
      vendedores: vendedores,
      redes: redes,
      tokenContrato: tokencontrato,
      valorMes: valorMes,
      segmento: segmento,
    })
  },

  showGraficoClientesSemMovimentacao: (empresaSelect, cidades, areas, vendedores, redes, tokencontrato, valorMes, segmento) => {
    return http.post(route + 'showGraficoClientesSemMovimentacao', {
      empresas: empresaSelect,
      cidades: cidades,
      areas: areas,
      vendedores: vendedores,
      redes: redes,
      tokenContrato: tokencontrato,
      valorMes: valorMes,
      segmento: segmento,
    })
  },

  showGraficoClientesNovosSemMovimentacao: (empresaSelect, cidades, areas, vendedores, redes, tokencontrato, valorMes, segmento) => {
    return http.post(route + 'showGraficoClientesNovosSemMovimentacao', {
      empresas: empresaSelect,
      cidades: cidades,
      areas: areas,
      vendedores: vendedores,
      redes: redes,
      tokenContrato: tokencontrato,
      valorMes: valorMes,
      segmento: segmento,
    })
  },

  showGraficoClientesNovosMovimentacao: (empresaSelect, cidades, areas, vendedores, redes, tokencontrato, valorMes, segmento) => {
    return http.post(route + 'showGraficoClientesNovosMovimentacao', {
      empresas: empresaSelect,
      cidades: cidades,
      areas: areas,
      vendedores: vendedores,
      redes: redes,
      tokenContrato: tokencontrato,
      valorMes: valorMes,
      segmento: segmento,
    })
  },

  showDadosClientesTotais: (empresaSelect, cidades, areas, vendedores, redes, tokencontrato, segmento) => {
    return http.post(route + 'showDadosClientesTotais', {
      empresas: empresaSelect,
      cidades: cidades,
      areas: areas,
      vendedores: vendedores,
      redes: redes,
      tokenContrato: tokencontrato,
      segmento: segmento,
    })
  },
}
